var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7539 10.3483V13.89C15.7539 14.2657 15.6047 14.626 15.339 14.8917C15.0733 15.1574 14.713 15.3066 14.3372 15.3066H4.42057C4.04485 15.3066 3.68451 15.1574 3.41884 14.8917C3.15316 14.626 3.00391 14.2657 3.00391 13.89V3.97331C3.00391 3.59758 3.15316 3.23725 3.41884 2.97157C3.68451 2.7059 4.04485 2.55664 4.42057 2.55664H7.96224V3.97331H4.42057V13.89H14.3372V10.3483H15.7539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7552 5.38997H12.9219V2.55664H11.5052V5.38997H8.67188V6.80664H11.5052V9.63997H12.9219V6.80664H15.7552V5.38997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.f845673c03bdad9b919ee86effd609b6.svg";
export { ForwardRef as ReactComponent };